import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Paginator } from 'primereact/paginator';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Message } from 'primereact/message';
import { Growl } from 'primereact/growl';
import { Dropdown } from 'primereact/dropdown';
import { FileUpload } from 'primereact/fileupload';
import servicioAsignacionValoresObjetos from '../servicios/ServicioAsignacionValoresObjetos';
import servicioTcCliente from '../servicios/ServicioTcCliente';
import servicioArchivo from '../servicios/ServicioArchivos';
import servicioUsuario from '../servicios/ServicioUsuario';

export class Cliente extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            cliente: {},
            mostraModalCliente: false,
            mostraModalInformacion: false,
            mostrarModalConfirmacion: false,
            mostraModalLogo: false,
            mostraModalEncabezado: false,
            erroresRequeridos: {},
            errores: {},
            paginacion: { registrosPorPagina: 20 },
            inicio: 0,
            mostraModalColor: false,
            idCliente:'',
            estados_cliente: [
                { name: 'Desactivado', code: 0 },
                { name: 'Activado', code: 1 }
            ],

        }
        this.changeComponentTheme = this.changeComponentTheme.bind(this);
        this.replaceLink = this.replaceLink.bind(this);
        this.isIE = this.isIE.bind(this);
    }
    componentDidMount() {
        this.obtenerPagina();
        this.validaEstatusUsuario();
    }
    validaEstatusUsuario() {
		
		servicioUsuario.cambiaContrasena().then((response) => {
            this.setState({idCliente:response.data.objeto.tcCliente.id});	
			

        }).catch((error) => {
           
                
        })


           
            

	}
    cambiaPagina(event) {
        let { paginacion } = this.state;
        paginacion.numeroPagina = event.page;
        paginacion.registrosPorPagina = event.rows;
        this.setState({ inicio: event.first, paginacion });
        this.obtenerPagina();
    }
    obtenerPagina() {
        let { paginacion } = this.state;


        servicioTcCliente.paginacion(paginacion).then((response) => {
            this.growl.show({ severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });

            if (response.data.error === false)
                this.setState({ paginacion: response.data.objeto });

        }).catch((error) => {
            if (error)
                return this.growl.show({ severity: 'error', summary: '', detail: 'Lo sentimos, se generó un error no esperado, por favor inténtelo de nuevo más tarde' });
        });
    }


    mostrarModal() {
        this.setState({ mostraModalCliente: true });
    }
    resetEstados() {
        this.setState({
            mostrarModalConfirmacion: false,
            mostraModalCliente: false,
            cliente: {}
        });
    }

    cerrarModalInformacion = () => {
        this.setState({ mostraModalInformacion: false, cliente: {} });
    }

    guardar() {
        let { cliente } = this.state;
        const validacion = this.validarFormulario(cliente);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            var clienteEnvio = JSON.parse(JSON.stringify(cliente));
            let estado = clienteEnvio.estado.code;
            cliente.estado = estado;
            servicioTcCliente.guardar(cliente).then((response) => {
                this.resetEstados();
                this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false) {
                    this.obtenerPagina();
                }
            }).catch((error) => {
            });
        }

    }

    editar_cliente = () => {
        let { cliente } = this.state;
        const validacion = this.validarFormulario(cliente);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            var clienteEnvio = JSON.parse(JSON.stringify(cliente));
            let estado = clienteEnvio.estado.code;
            cliente.estado = estado;
            servicioTcCliente.editar_cliente(cliente).then((response) => {
                this.cerrarModalInformacion();
                this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                if (response.data.error === false) {
                    this.obtenerPagina();
                }
            }).catch((error) => {
            });
        }
    }

    editar_logo = () => {
        let { cliente } = this.state;
        const validacion = this.validarLogo(cliente);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            servicioTcCliente.editar_logo(cliente).then((response) => {
                this.cerrarModalLogo();
                this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                window.location.reload(true);
                if (response.data.error === false) {
                    this.obtenerPagina();
                }
            }).catch((error) => {
            });
        }


    }
    editar_color = (color) => {

        let { cliente } = this.state;
        if(this.state.idCliente==cliente.id){
        this.changeComponentTheme(color);
        }
        cliente.color = color;
        servicioTcCliente.editar_color(cliente).then((response) => {
            this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            this.cerrarModalColor();
           // window.location.reload(true);
           if (response.data.error === false) {
                this.obtenerPagina();
            }
       }).catch((error) => {
       });


    }

    validarLogo = (cliente) => {
        const errores = {};
        if (!cliente.logo)
            errores.logo = "El campo es requerido";
        return errores;
    };


    editar_encabezado = () => {
        let { cliente } = this.state;
        const validacion = this.validarfondo(cliente);
        this.setState({ errores: validacion });
        if (!Object.keys(validacion).length) {
            servicioTcCliente.editar_encabezado(cliente).then((response) => {
                this.cerrarModalEncabezado();
                this.growl.show({ life: 6000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
                window.location.reload(true);
                if (response.data.error === false) {
                    this.obtenerPagina();
                }
            }).catch((error) => {
            });
        }

    }

    validarfondo = (cliente) => {
        const errores = {};
        if (!cliente.fondo)
            errores.fondo = "El campo es requerido";
        return errores;
    };

    eliminar = () => {
        let { cliente } = this.state;
        servicioTcCliente.eliminar(cliente).then((response) => {
            this.growl.show({ life: 4000, severity: (response.data.error === false ? 'success' : 'error'), summary: '', detail: response.data.mensaje });
            if (response.data.error === false) {
                this.resetEstados();
                this.obtenerPagina();
            }
        }).catch((error) => {
        });
    }
    preeditar(objeto) {
        let { estados_cliente } = this.state;
        let estado_cliente = estados_cliente.filter(obj => {
            return obj.code === objeto.estado;
        });
        var clienteEditar = JSON.parse(JSON.stringify(objeto));
        let estado = estado_cliente[0];
        delete clienteEditar['estado'];
        clienteEditar.estado = estado;

        this.setState({ mostraModalInformacion: true, cliente: clienteEditar });
    }
    validarFormulario = (cliente) => {
        const errores = {};
        if (!cliente.nombre)
            errores.nombre = "El campo es requerido";
        if (!cliente.estado)
            errores.estado = "El campo es requerido";
        return errores;
    };
    asignarValores = (event) => {
        servicioAsignacionValoresObjetos.asignarAtributosObjeto(event, this, false);
    }
    plantillaOpciones(rowData, column) {
        return <div className="p-grid">

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.preeditar(column.rowData)} className="p-button-warning" name="editar"
                    tooltip="editar" >
                </Button>
            </div>
        </div>;
    }

    editarLogo(rowData, column) {
        return <div className="p-grid">

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.preeditarLogo(column.rowData)} className="p-button-warning" name="editar"
                    tooltip="editar" >
                </Button>
            </div>
        </div>;
    }

    editarEncabezado(rowData, column) {
        return <div className="p-grid">

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.preeditarEncabezado(column.rowData)} className="p-button-warning" name="editar"
                    tooltip="editar" >
                </Button>
            </div>
        </div>;
    }
    editarColor(rowData, column) {
        return <div className="p-grid">

            <div className="p-col-12 p-md-2">
                <Button type="button" icon="pi-md-edit" onClick={(e) => this.preeditarColor(column.rowData)} className="p-button-warning" name="editar color"
                    tooltip="editar color" >
                </Button>
            </div>
        </div>;
    }

    preeditarLogo = (objeto) => {
        this.setState({ mostraModalLogo: true, cliente: objeto });
    }

    preeditarEncabezado = (objeto) => {
        this.setState({ mostraModalEncabezado: true, cliente: objeto });
    }
    preeditarColor = (objeto) => {
        this.setState({ mostraModalColor: true, cliente: objeto });
    }

    mostrarModalEliminar = (objeto) => {
        this.setState({ mostrarModalConfirmacion: true, cliente: objeto });
    }
    formatoEstado = (rowData, column) => {
        if (rowData.estado == 1)
            return <p style={{ backgroundColor: '#33ff4c', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Activo</p>;
        else
            return <p style={{ backgroundColor: '#f008', borderWidth: 1, borderColor: '#000', borderRadius: 12, padding: 8 }}>Desactivado</p>
    }
    formatoImagen = (rowData, column) => {
        if (rowData.logo != null)
            return <img width="100px" height="100px" src={`data:image/png;base64,${rowData.logo}`} />

    }
    formatoImagenFondo = (rowData, column) => {
        if (rowData.fondo != null)
            return <img width="100px" height="100px" src={`data:image/png;base64,${rowData.fondo}`} />

    }
    formatoColor = (rowData, column) => {
        if (rowData.color != null)
            return <img width="100px" height="100px"  src={"../../assets/layout/images/configurator/theme/" +rowData.color+".svg" } />

    }
    leerLogo = (event) => {
        let { cliente } = this.state;
        servicioArchivo.obtenerBytesBase64StringArchivo(event.files[0], cliente, 'logo');
        this.setState(cliente);
        this.growl.show({ life: 5000, severity: 'success', summary: 'Success', detail: 'la imagen se cargo con exito' });
    }
    leerFondo = (event) => {
        let { cliente } = this.state;
        servicioArchivo.obtenerBytesBase64StringArchivo(event.files[0], cliente, 'fondo');
        this.setState(cliente);
        this.growl.show({ life: 5000, severity: 'success', summary: 'Success', detail: 'la imagen se cargo con exito' });
    }

    cerrarModalLogo = () => {
        this.setState({ mostraModalLogo: false, cliente: {}, errores: {} });
    }
    cerrarModalColor = () => {
        this.setState({ mostraModalColor: false, cliente: {}, errores: {} });
    }


    cerrarModalEncabezado = () => {
        this.setState({ mostraModalEncabezado: false, cliente: {}, errores: {} });
    }
    changeComponentTheme(event) {
		
		this.setState({themeColor: event});

		let element = document.getElementById('theme-css');
		let urlTokens = element.getAttribute('href').split('/');
		urlTokens[urlTokens.length - 1] = 'theme-' + event + '.css';
		let newURL = urlTokens.join('/');

		this.replaceLink(element, newURL);

	//	event.originalEvent.preventDefault();
		
    }
    replaceLink(linkElement, href) {
		if(this.isIE()){
			linkElement.setAttribute('href', href);
		}
		else {
			const id = linkElement.getAttribute('id');
			const cloneLinkElement = linkElement.cloneNode(true);

			cloneLinkElement.setAttribute('href', href);
			cloneLinkElement.setAttribute('id', id + '-clone');

			linkElement.parentNode.insertBefore(cloneLinkElement, linkElement.nextSibling);

			cloneLinkElement.addEventListener('load', () => {
				linkElement.remove();
				cloneLinkElement.setAttribute('id', id);
			});
		}
	}
	isIE() {
		return /(MSIE|Trident\/|Edge\/)/i.test(window.navigator.userAgent)
	}

    render() {
        let { cliente, errores, estados_cliente, paginacion, inicio } = this.state;
        const pieDialogo = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Guardar" icon="pi-md-check" onClick={this.guardar.bind(this)} />
            <Button label="Cancelar" icon="pi-md-close" onClick={this.resetEstados.bind(this)} className="p-button-danger " />
        </div>;

        const pieDialogoInformacion = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Guardar" icon="pi-md-check" onClick={this.editar_cliente} />
            <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalInformacion} className="p-button-danger " />
        </div>;

        const pieDialogoLogo = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Guardar" icon="pi-md-check" onClick={this.editar_logo} />
            <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalLogo} className="p-button-danger " />
        </div>;

        const pieDialogoEncabezado = <div className="ui-dialog-buttonpane p-clearfix">
            <Button label="Guardar" icon="pi-md-check" onClick={this.editar_encabezado} />
            <Button label="Cancelar" icon="pi-md-close" onClick={this.cerrarModalEncabezado} className="p-button-danger " />
        </div>;

        const dialogFooterConfirmacionEliminar = (
            <div>
                <Button icon="pi-md-check" onClick={this.eliminar} label="Si estoy seguro" className="teal-btn flat-btn" />
                <Button icon="pi-md-close" onClick={() => this.setState({ cliente: {}, mostrarModalConfirmacion: false, errores: {} })} label="No estoy seguro" className="p-button-danger flat-btn" />
            </div>
        );
        let componentThemes = [
            { name: 'Amber', file: 'amber', image: 'amber.svg' },
            { name: 'Blue', file: 'blue', image: 'blue.svg' },
            { name: 'Bluegray', file: 'bluegray', image: 'bluegray.svg' },
            { name: 'Brown', file: 'brown', image: 'brown.svg' },
            { name: 'Cyan', file: 'cyan', image: 'cyan.svg' },
            { name: 'Deep Orange', file: 'deeporange', image: 'deeporange.svg' },
            { name: 'Deep Purple', file: 'deeppurple', image: 'deeppurple.svg' },
            { name: 'Gray', file: 'gray', image: 'gray.svg' },
            { name: 'Green', file: 'green', image: 'green.svg' },
            { name: 'Indigo', file: 'indigo', image: 'indigo.svg' },
            { name: 'Light Blue', file: 'lightblue', image: 'lightblue.svg' },
            { name: 'Light Green', file: 'lightgreen', image: 'lightgreen.svg' },
            { name: 'Lime', file: 'lime', image: 'lime.svg' },
            { name: 'Orange', file: 'orange', image: 'orange.svg' },
            { name: 'Pink', file: 'pink', image: 'pink.svg' },
            { name: 'Purple', file: 'purple', image: 'purple.svg' },
            { name: 'Teal', file: 'teal', image: 'teal.svg' },
            { name: 'Yellow', file: 'yellow', image: 'yellow.svg' }
        ];
        return (
            <div className="p-grid">
                <Growl ref={(el) => this.growl = el} />
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <h1>Clientes</h1>
                        <div className="p-fluid p-grid">
                            <div className="p-col-12 p-md-4">
                                <Button className="p-button-Primary p-button-raised" label="Agregar"
                                    icon="pi-md-plus" tooltip={"Agregar nuevo"} onClick={this.mostrarModal.bind(this)} />
                            </div>


                        </div>
                    </div>
                </div>
                <Dialog visible={this.state.mostraModalCliente} header="Datos del Cliente" footer={pieDialogo} onHide={this.resetEstados.bind(this)}>
                    <h4>Los campos con (*) son obligatorios, por favor captura los datos del cliente</h4>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="rfc">*Nombre:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <InputText id="nombre" name="cliente.nombre" className={errores.nombre ? 'p-error' : ''} value={cliente.nombre || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                            {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="estado">*Estado:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <Dropdown id="estado" name="cliente.estado" options={estados_cliente} value={cliente.estado} onChange={this.asignarValores} placeholder="Selecciona" optionLabel="name" className={errores.estado ? 'p-error' : ''} autoWidth={false} />
                            {errores.estado ? <div> <Message severity="error" text={errores.estado} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="logo">Logo:</label>

                        </div>
                        <div className="p-col-12 p-md-4">
                            <FileUpload mode="basic" name="cliente.logo" className={errores.logo ? 'p-error' : ''} value={cliente.logo || ''}
                                chooseLabel=".png" onSelect={this.leerLogo} accept=".png" auto={true} />
                        </div>

                        <div className="p-col-12 p-md-2">
                            <label htmlFor="fondo">Diseño:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <FileUpload mode="basic" name="cliente.fondo" className={errores.fondo ? 'p-error' : ''} value={cliente.fondo || ''}
                                chooseLabel=".png" onSelect={this.leerFondo} accept=".png" auto={true} />
                        </div>

                    </div>
                </Dialog>
                <Dialog visible={this.state.mostraModalInformacion} header="Información del Cliente" footer={pieDialogoInformacion} onHide={this.cerrarModalInformacion}>
                    <h4>Los campos con (*) son obligatorios, por favor captura los datos del cliente</h4>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="rfc">*Nombre:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <InputText id="nombre" name="cliente.nombre" className={errores.nombre ? 'p-error' : ''} value={cliente.nombre || ''} onChange={this.asignarValores.bind(this)} style={{ width: '100%' }} />
                            {errores.nombre ? <div><br /> <Message severity="error" text={errores.nombre} /> </div> : null}
                        </div>
                        <div className="p-col-12 p-md-2">
                            <label htmlFor="estado">*Estado:</label>
                        </div>
                        <div className="p-col-12 p-md-4">
                            <Dropdown id="estado" name="cliente.estado" options={estados_cliente} value={cliente.estado} onChange={this.asignarValores} placeholder="Selecciona" optionLabel="name" className={errores.estado ? 'p-error' : ''} autoWidth={false} />
                            {errores.estado ? <div> <Message severity="error" text={errores.estado} /> </div> : null}
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={this.state.mostraModalLogo} header="Editar Logo" footer={pieDialogoLogo} onHide={this.cerrarModalLogo}>
                    <h4>Los campos con (*) son obligatorios</h4>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12">
                            <label htmlFor="logo">* Logo:</label>

                        </div>
                        <div className="p-col-12">
                            <FileUpload mode="basic" name="cliente.logo" value={cliente.logo || ''}
                                chooseLabel=".png, .jpg" onSelect={this.leerLogo} accept=".png, .jpg" auto={true} className={errores.logo ? 'p-error' : ''} />
                            {errores.logo ? <div><br /> <Message severity="error" text={errores.logo} /> </div> : null}
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={this.state.mostraModalColor} header="Editar Color" onHide={this.cerrarModalColor}>
                    <h4>Seleccione un Color</h4>
                    <div className="p-grid">
                        {componentThemes && componentThemes.map((componentTheme, index) => {
                            return <div className="p-col" key={index}>
                                <button className='p-link layout-config-option layout-config-option-image ui-shadow-1'
                                   onClick={event => this.editar_color(componentTheme.file)}	>
                                 
                                    <img src={"../../assets/layout/images/configurator/theme/" + componentTheme.image} alt={componentTheme.name} />
                                    {componentTheme.file === this.props.themeColor && <i className="material-icons">check</i>}
                                </button>
                            </div>
                        })
                        }
                    </div>

                </Dialog>

                <Dialog visible={this.state.mostraModalEncabezado} header="Editar Diseño" footer={pieDialogoEncabezado} onHide={this.cerrarModalEncabezado}>
                    <h4>Los campos con (*) son obligatorios</h4>
                    <div className="p-grid p-fluid">
                        <div className="p-col-12">
                            <label htmlFor="fondo">Diseño:</label>
                        </div>
                        <div className="p-col-12">
                            <FileUpload mode="basic" name="cliente.fondo" className={errores.fondo ? 'p-error' : ''} value={cliente.fondo || ''}
                                chooseLabel=".png, .jpg" onSelect={this.leerFondo} accept=".png, .jpg" auto={true} />
                            {errores.fondo ? <div><br /> <Message severity="error" text={errores.fondo} /> </div> : null}
                        </div>
                    </div>
                </Dialog>



                <Dialog header="Confirmación" visible={this.state.mostrarModalConfirmacion} modal={true} style={{ width: '30vw' }} footer={dialogFooterConfirmacionEliminar} onHide={() => this.setState({ cliente: {}, mostrarModalConfirmacion: false, errores: {} })}>
                    <h2>¿Estás seguro de eliminar el cliente?</h2>
                </Dialog>
                <div className="p-col-12">
                    <div className="card card-w-title">
                        <DataTable value={paginacion.datos} editable={true} selectionMode="single" responsive={true} header="Clientes" >
                            <Column field="nombre" header="Nombre" autoLayout={true} />
                            <Column field="estado" body={this.formatoEstado} header="Estado" autoLayout={true} />
                            <Column field="logo" body={this.formatoImagen} header="Logo" autoLayout={true} />
                            <Column field="fondo" body={this.formatoImagenFondo} header="Diseño" autoLayout={true} />
                            <Column field="color" body={this.formatoColor} header="Color" autoLayout={true} />
                            <Column header="Editar Información" body={this.plantillaOpciones.bind(this)} autoLayout={true} />
                            <Column header="Editar Logo" body={this.editarLogo.bind(this)} autoLayout={true} />
                            <Column header="Editar Diseño" body={this.editarEncabezado.bind(this)} autoLayout={true} />
                            <Column header="Editar Color" body={this.editarColor.bind(this)} autoLayout={true} />
                        </DataTable>
                        <Paginator first={inicio} rows={paginacion.registrosPorPagina} totalRecords={paginacion.registrosTotales} onPageChange={this.cambiaPagina.bind(this)} rowsPerPageOptions={[20, 40, 60, 80, 100]} />
                    </div>
                </div>
            </div>

        )
    }
}
